const condition = {
  bindings: {
    index: '<',
    newCondition: '<',
    viewMode: '<',
    onRemove: '&',
    onSave: '&',
    onEdit: '&',
  },
  templateUrl: '/modules/psa/script-form/condition/condition.html',
  controller: 'ConditionController',
};

angular
  .module('psa.module')
  .component('condition', condition);
